export default "__VITE_ASSET__5f35143a__"